import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col, Form, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import { consts, Translate, components, utils, Actions as actions, Form as CoreForm } from 'unity-core'
const { Routes } = consts
const { getEnv } = utils
const { AlertPanel, Loader, NavLink } = components
import { bindActionCreators } from 'redux'
import DOMPurify from 'dompurify'
import { push } from 'react-router-redux'

const propTypes = {
  redirectRoute: PropTypes.string,
  isAuthenticating: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  accessCode: PropTypes.string,
  err: PropTypes.object,
  notice: PropTypes.object,
  strings: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  clearErr: PropTypes.func.isRequired,
  // getAppNotice: PropTypes.func.isRequired
}
const defaultProps = {
  isAuthenticating: false,
  isAuthenticated: false,
  redirectRoute: `/${Routes.HOME}`,
  accessCode: "",
  err: null,
  notice: {}
}

export class SSOLanding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  //this is to make sure we are getting imgs from correct folder so html generated by Word would work
  setDOMHook() {
    DOMPurify.removeHook('afterSanitizeAttributes')
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      if (node.nodeName && node.nodeName.toLowerCase() === 'img') {
        if (node.hasAttribute('src') && node.getAttribute('src').indexOf('://') === -1) {
          node.setAttribute('src', 'releaseNotes/' + this.props.lang.value + '/' + node.getAttribute('src'))
        }
      }
    });
  }

  removeDOMHook() {
    DOMPurify.removeHook('afterSanitizeAttributes')
  }

  componentDidMount() {
    const { accessCode, redirectRoute, isAuthenticated, isAuthenticating } = this.props;

    this.setDOMHook();
    this.props.getAppNotice();
    this.props.clearErr();
    if (accessCode && !isAuthenticating && !isAuthenticated) {
      this.props.login("accesscode", accessCode, redirectRoute);
    }

  }

  componentWillUnmount() {
    this.removeDOMHook();
  }

  componentDidUpdate(prevProps) {
    const { changeRoute, redirectRoute, accessCode } = this.props;

    if (prevProps.lang.value != this.props.lang.value) {
      this.setDOMHook()
      this.props.getAppNotice()
    }

    if (!this.props.isAuthenticating && accessCode) {
      if (!this.props.isAuthenticated) {
        changeRoute(`/login${redirectRoute ? `?redirect=${redirectRoute}`: `` }`);
      }
    }
  }

  dismissAlert = () => {
    this.props.clearErr()
  }

  getErrorMessage = (error) => {
    const { strings } = this.props
    if (!error) {
      return ''
    }
    if (error.response) { //API EXCEPTION
      return `${error.response.status} - ${error.message} - ${strings.Login.apiResponseErrors[error.response.status]}`
    }
    if (error.message) {  //TIMEOUT EXCEPTION
      return strings[error.message] || error.message
    }
    return error.toString()
  }

  getUrlComponentsFromQuery = (query) => {
    return Object.keys(query)
      .map(key => `${key}=${query[key]}`)
      .join("&");
  }

  render() {
    const { err, strings, notice, query } = this.props
    const urlComponents = this.getUrlComponentsFromQuery(query);
    let errorMessage = this.getErrorMessage(err) //GET THE ERROR MESSAGE
    const callBackUrl = `${window.location.origin}/#/login${urlComponents ? `?${urlComponents}` : ``}`;
    const errorCallbackUrl = `${window.location.origin}/#/login-error`;
    const SsoLoginUrl =
      `${getEnv().SsoLoginUrl}?callbackUrl=${encodeURIComponent(callBackUrl)}&errorCallbackUrl=${encodeURIComponent(errorCallbackUrl)}`;

    return (
      <div className="login-container">
        <Grid fluid className="slide-top-100">
          <Row>
            <Col md={4}>
              <div>
                <br />
              </div>
              <div className="sso-login-block">
                <Loader loaded={!this.props.isAuthenticating}>
                  <AlertPanel msg={errorMessage} show={!_.isEmpty(err)} onDismiss={this.dismissAlert} />
                  <div className="title justify-content">
                    Unity Sign in
                  </div>
                  <div className="body justify-content">
                    Click below to sign in to the Unity Portal
                  </div>
                  <div className="btn-group justify-content">
                    <Button
                      href={SsoLoginUrl}
                      disabled={this.props.isAuthenticating}
                    >
                      {strings.Login.Submit}
                    </Button>
                  </div>
                </Loader>
              </div>
              <div className="justify-content">
                    <a style={{ cursor: 'pointer', fontWeight: 'bold' }} href={getEnv().ForgotPasswordUrl}>
                      {strings.ForgotPassword.link}
                    </a>
                  </div>
            </Col>
            <Col md={8}>
              <div>
                <br />
              </div>
              <div className="notice">
                <div className="notice-content">
                  <div className="notice-title">
                    <b>Welcome to the Unity Portal</b>
                  </div>
                  <div className="notice-body">
                    If you need help using this tool please visit the wiki here.
                    <a href="https://uwiki.opal.dnb.com" target="_blank" className="btn btn-primary btn-xs btn-with-icon">Unity Wiki <i className="glyphicon glyphicon-chevron-right" /></a>
                  </div>
                  <hr />
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notice.content) }}></div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

SSOLanding.propTypes = propTypes
SSOLanding.defaultProps = defaultProps

const mapStateToProps = (state, ownProps) => ({
  query: ownProps.location.query,
  redirectRoute: ownProps.location.query.redirect,
  accessCode: ownProps.location.query.accesscode,
  isAuthenticating: state.user.isAuthenticating,
  isAuthenticated: state.user.isAuthenticated,
  notice: state.app.notice,
  lang: state.user.lang,
  err: state.user.err
});
const mapDispatchToProps = (dispatch) => ({
  login: bindActionCreators(actions.User.login, dispatch),
  clearErr: bindActionCreators(actions.User.clearErr, dispatch),
  getAppNotice: () => dispatch(actions.App.getAppNotice()),
  changeRoute: route => dispatch(push(route))
})

const decorators = _.flow([
  connect(mapStateToProps, mapDispatchToProps),
  Translate('Login', 'ForgotPassword')
]);

export default decorators(SSOLanding)
